export const Role = {
    Owner: 1,
    Admin: 2,
    Editor: 3,
    Auditor: 4,
    Advisor: 5,
    // Back-compat alias — `Staff` was the old name for role 5 (now Advisor).
    Staff: 5,
}

export function hasRole(requiredRoles, userRole) {
    return requiredRoles.includes(userRole);
}

// GSTC Auditor (4) — certifies: reviews submitted tasks, approves / requests
// changes. Scoped to ASSIGNED companies (advisorCompanyAccess).
export function isAuditor(userRole) {
    return userRole === Role.Auditor;
}

// Sustainability Advisor (5) — advises: full read-only view of the assigned
// company, may request changes but NOT approve/certify.
export function isAdvisor(userRole) {
    return userRole === Role.Advisor;
}

// Either advisor-center persona (Auditor 4 or Advisor 5). Both are scoped to
// their ASSIGNED companies — the cross-company "all" view lives in the backoffice.
export function hasAdvisorAccess(userRole) {
    return userRole === Role.Auditor || userRole === Role.Advisor;
}

// Back-compat shims (older imports). `isStaff` === advisor; `isAuditorOrStaff`
// === any advisor-center persona.
export function isStaff(userRole) {
    return userRole === Role.Advisor;
}
export function isAuditorOrStaff(userRole) {
    return hasAdvisorAccess(userRole);
}